import { render, staticRenderFns } from "./eslrecordlist.vue?vue&type=template&id=97e985ac&scoped=true"
import script from "./eslrecordlist.vue?vue&type=script&lang=js"
export * from "./eslrecordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e985ac",
  null
  
)

export default component.exports